import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { EmployeeGroup } from "@/Common/Api/Employee/Dto/EmployeeGroup";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IGroupSearchComponentProps {
    model: IGroupTabModel;
    operation: number;
    selectedGroup?: EmployeeGroupUIModel;
}

class GroupSearchComponentState {
    public searchResult: EmployeeGroupUIModel[];
    public textSearch: string;
}

class GroupSearchComponent extends BaseReactComponent<IGroupSearchComponentProps, GroupSearchComponentState> {
    public constructor(props: Readonly<IGroupSearchComponentProps>) {
        super(props);
        this.state = {
            textSearch: props.model.get("SearchText") ? props.model.get("SearchText") : "",
            searchResult: []
        };
    }

    public componentDidMount(): void {
        sessionStore.dispatch(this.props.operation);
    }

    public componentDidUpdate(prevProps: Readonly<IGroupSearchComponentProps>, prevState: Readonly<GroupSearchComponentState>): void {
        let currentSearchResults = prevProps.model.get("SearchGroupResult");
        let nextSearchResults = this.props.model.get("SearchGroupResult");
        let isSameSearch = prevProps.model.get("SearchText") == this.props.model.get("SearchText") || this.state.textSearch != this.props.model.get("SearchText") || this.state.textSearch != prevState.textSearch;

        if (currentSearchResults !== nextSearchResults || !isSameSearch) {
            this.mutateState(s => {
                s.searchResult = nextSearchResults.sortByProperty(x => x.Model.Name);
                s.textSearch = this.props.model.get("SearchText");
            });
        }
    }

    public render(): JSX.Element {
        let self = this;
        let groups: EmployeeGroupUIModel[] = [];

        if (this.state != null && this.state.searchResult != null) {
            groups = this.state.searchResult;
            if (groups != null && groups.length > 0) {
                groups = groups.sortByProperty(x => x.Model.Name);
            }
        }

        if (!IsNullOrWhiteSpace(this.state.textSearch)) {
            groups = groups.filterSearch(this.state.textSearch, item => item.Name);
        }

        return (
            <div className="fxheight transition full-border admin-users-search">

                <div className="user-search">
                    <div className="flex-container s">
                        <div className="search-field" style={{ width: "100%", maxHeight: "40px" }}>
                            <div className="gf">
                                <span className="glyphicon glyphicon-search" />
                            </div>
                            <div style={{ width: "100%" }}>
                                <TextboxControl
                                    onMountFocus={true}
                                    debounceMs={400}
                                    value={this.state.textSearch}
                                    name="text_search_users"
                                    className="fullWidth"
                                    operation={null}
                                    placeholder={cacheStore.GetString("SearchLabel")}
                                    autoComplete="off"
                                    onChange={value => self.mutateState(
                                        s => s.textSearch = value,
                                        () => sessionStore.dispatch(LocalOperations.AdministrationGroup.SetTextSearch, { TextSearch: value })
                                    )}
                                    autoCompleteItems={null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="patient-create-options flex-container" style={{ display: "flex", justifyContent: "flex-end" }}>

                        <div className="flx-col" style={{ textAlign: "right" }}>
                            <a style={{ "textDecoration": "underline", "marginRight": "10px" }} onClick={() => this.openNewGroupPopUp()}> {"+ " + cacheStore.GetString("AddNewGroupLabel")}</a>
                        </div>

                    </div>

                </div>
                <div className="user-search-results scrollable">
                    <div className="pointer">
                        {groups.map((x: EmployeeGroupUIModel, i: number) => {
                            let selectedClass = "";
                            if (self.props.selectedGroup != null) {
                                selectedClass = (x.Model.Id == self.props.selectedGroup.Model.Id) ? " selected" : "";
                            }

                            return (
                                <div className={"user-search-item" + selectedClass} id={"__a" + i} key={i + "___rr"} onClick={() => this.selectItem(x.Model)}>
                                    <div className="user-search-ellipsis">
                                        <strong>   {x.Model.Name.charAt(0).toUpperCase() + x.Model.Name.slice(1)}  </strong>
                                    </div>
                                    <div />
                                    <div>
                                        {x.Model.EmployeeContactFacetIds.length.toString() + " " + cacheStore.GetString("user(s)Label")}
                                    </div>
                                </div>

                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    private openNewGroupPopUp(): void {
        sessionStore.dispatch(LocalOperations.AdministrationGroup.OpenCreateNewGroupPopup);
    }

    private selectItem(item: EmployeeGroup): void {
        sessionStore.dispatch(LocalOperations.AdministrationGroup.GetGroupInfo, { GroupId: item.Id });
    }
}

export { GroupSearchComponent };
